<div class="flex-container gap-16" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.delta_treso' | trans" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  @if (metadata().loading) {
    <div class="overflow-hidden widget-content">
      <div class="flex-row gap-32 align-end">
        <ngx-skeleton-loader count="1" [theme]="{'height': '200px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '140px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '220px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '110px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '90px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '30px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>

      </div>
    </div>
  } @else if (data()?.data?.length) {
    <div class="h100 fade-in">
      <canvas #cadelta></canvas>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
